import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import produce from 'immer';
export const SEARCH_LOCALSTORAGE_KEY = 'academy:search';
export const useSearchState = create()(persist(set => ({
  lastClickedSearchResultItem: null,
  setLastClickedSearchResultItem: searchResult => set(produce(state => {
    state.lastClickedSearchResultItem = searchResult;
  })),
  clearLastClickedSearchResultItem: () => set(produce(state => {
    state.lastClickedSearchResultItem = null;
  }))
}), {
  name: SEARCH_LOCALSTORAGE_KEY
}));